export interface NavItem {
  id: string;
  label: string;
  children?: Array<{ id: string; label: string }>;
}

/** Single source of truth for the sidebar and the section ids it scrolls to. */
export const NAV: NavItem[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'prerequisites', label: 'What you need first' },
  { id: 'quickstart', label: 'Quickstart' },
  { id: 'validator', label: 'Manifest validator' },
  {
    id: 'manifest',
    label: 'Manifest reference',
    children: [
      { id: 'manifest-service', label: 'Service' },
      { id: 'manifest-scheduled', label: 'Scheduled tasks' },
    ],
  },
  {
    id: 'action',
    label: 'Action reference',
    children: [
      { id: 'action-inputs', label: 'Inputs' },
      { id: 'action-outputs', label: 'Outputs' },
    ],
  },
  { id: 'construct-mode', label: 'Use with your CDK app' },
  { id: 'ownership', label: 'What the stack owns' },
  {
    id: 'examples',
    label: 'Examples',
    children: [
      { id: 'examples-manifests', label: 'Manifests' },
      { id: 'examples-workflows', label: 'Workflows' },
    ],
  },
];
